import { gql } from "@apollo/client";

export const scheduleCheckQuery = gql`
    query($requiredRestHours: Float!, $newEndDateTime: String!, $newStartDateTime: String!, $employeeId: String!){
        scheduleCheck(requiredRestHours: $requiredRestHours, newEndDateTime: $newEndDateTime, newStartDateTime: $newStartDateTime, employeeId: $employeeId) {
            message
            response
        }
    }
`;